import {isNotNilOrEmpty} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export const placeholderFallback = (value: string | Nullish) =>
  isNotNilOrEmpty(value) ? (value as string) : EMPTY_PLACEHOLDER;
